import styled from '@emotion/styled';

export const StyledVerticalPromoCode = styled.div`
    border-radius: 20px;
    box-sizing: border-box;
    width: calc(100% - 48px);
    max-width: 400px;
    text-align: center;
    z-index: 1;

    .box {
        background-color: white;
        padding: 16px;
        gap: 16px;
    }

    .main-content {
        display: flex;
        flex-direction: column;
        padding-top: 32px;
        padding-bottom: 32px;
    }

    .header {
        display: flex;
        border-radius: 16px 16px 0 0;
        border-bottom: 1px solid #DDE0E4;
        justify-content: center;
    }

    .footer {
        display: flex;
        flex-direction: column;
        border-radius: 0 0 16px 16px;
        border-top: 1px solid #DDE0E4;
    }

    .promo-code-input {
        position: relative;
        width: 100%;
        height: 48px;

        .icon {
            position: absolute;
            height: 48px;
            width: 32px;
            pointer-events: none;
        }

        .icon-left {
            left : 20px;
        }

        .icon-right {
            right : 12px;
        }

        .close {
            cursor: pointer;
            pointer-events: unset;
        }

        input {
            border: 1px solid #99A1AF;
            border-radius: 80px;

            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            padding-left: 64px;
            padding-right: 56px;
        }

        input:focus {
            outline: none;
            border: 1px solid #000;
            box-shadow: 0px 0px 8px #E4E6EA;
        }
    }
`;

export const StyledPromoCodeContainer = styled.div<{
  size: 'sm' | 'md' | 'lg';
}>`
    width: ${({ size }) => (size === 'sm' ? '100%' : 'unset')};
    position: relative;
    background: #fff;
    border: 1px solid #99A1AF;
    border-radius: 80px;
    padding: ${({ size }) => (size === 'sm' ? '3px 6px' : '6px')};
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;

    .verticalSeparator {
        position: relative;
        width: 1px;
        background-color: #99A1AF;
        height: 32px;
    }
`;

export const StyledPromoCode = styled.div<{ size?: 'sm' | 'md' | 'lg' }>`
    position: relative;
    width: 100%;
    max-width: 120px;
    height: 40px;
    flex-grow: 1;

    display: flex;
    align-items: center;
    gap: 8px;

    input {
        font-size: 14px;
        width: ${({ size }) =>
          size === 'sm' ? '100%' : 'calc(100% - 32px)'}; ;
        position: relative;
    }

    input[value=""] {
        width: 100%;
    }

    input:focus {
        outline: none;
    }

    .clear-promo {
        width: 24px;
        height: 24px;
        cursor: pointer;
        background: #F8F9FA;
        border-radius: 50%;
    }
`;
